export default __webpack_public_path__ + "static/media/ts.9ca86337.png";